module.exports = __webpack_public_path__ + "static/media/btn3.63b24f73.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_139/images/btn3.png
// module id = 1357
// module chunks = 0